import React from "react";
import MonthlyReportsComponent from "../monthly/MonthlyReportsComponent";
import ReportDTO from "../../../../models/finance/Reports";
import { FinanceType } from "../../../../models/finance/FinanceType";

interface ExpensesMonthlyReportsComponentPropos {
  report: ReportDTO;
  year: number;
  month: string;
}

const ExpensesMonthlyReportsComponent: React.FC<
  ExpensesMonthlyReportsComponentPropos
> = ({ report, year, month }) => {
  return (
    <>
      <MonthlyReportsComponent
        year={year}
        month={month}
        report={report}
        type={FinanceType.EXPENSE}
      />
    </>
  );
};

export default ExpensesMonthlyReportsComponent;
